module.exports = __webpack_public_path__ + "img/sfs_logo.7896692d.png";